import type { ReportId } from 'ag-common-lib/lib/contracts/reporting-api.contracts';

export const REPORTS_VIEWER_COMPARISON_ROUTE_PATH = 'comparison-dashboard';
export const REPORTS_VIEWER_PRODUCTION_HISTORY_ROUTE_PATH = 'production-history';
export const REPORTS_VIEWER_PRODUCTION_RECONCILIATION_ROUTE_PATH = 'production-reconciliation';

/** Report ids use dashes in URLs (`mga-paid`); the report page maps them back. */
export const toReportRouteId = (reportId: ReportId): string => reportId.replace(/_/g, '-');
